import { Flex } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { CreateTicketFromScheduleOption } from "./CreateTicketFromScheduleOption";
import { TicketLifetimeOption } from "./TicketLifetimeOption";

export const GeneralOptions = observer(() => {
  return (
    <Flex vertical gap={48} align="flex-start" justify="start">
      <TicketLifetimeOption />
      <CreateTicketFromScheduleOption />
    </Flex>
  );
});
